// extracted by mini-css-extract-plugin
export default {"cell":"CalendarHeaderCell_cell__BEdtM","inner-text":"CalendarHeaderCell_inner-text__9n3pM"};